import { LicenseInfo } from '@mui/x-license-pro';

LicenseInfo.setLicenseKey('aa558573f53c6e0c2d937e8f120f50e9Tz0xMjIwNzgsRT0xNzk1MjE5MTk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI=');
// LicenseInfo.setLicenseKey('7f62291a6a76f5c61421c08c0e69739bTz03NjEyNyxFPTE3MjgyMDY2NjUwMDAsUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI=');
// LicenseInfo.setLicenseKey('a230477be211d06ee899d2355fac06e5Tz03NjEyNyxFPTE3MDQ4NDQ4MDAwMDAsUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI=');
// LicenseInfo.setLicenseKey('519ae9c1693e36ee0c4db02c210cbf45Tz03NjEyNyxFPTE4MzAyMTEyMDAwMDAsUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI=');

export default function MuiXLicense() {
    return null;
}